import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListTablePayload } from '@app-store/slices/table/list'

interface TaskAction extends Action {
    payload: IListTablePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.list

function* listTableSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting/table`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result.data)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listTableSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listTableSagaTask)
}

export default listTableSaga
